<script lang="ts">
	import { Input } from "flowbite-svelte";
	import { arrayFromArrayValue, arrayToArrayValue } from "#lib/array.js";
	import Icon from "#lib/components/Icon.svelte";
	import type { DataTypeInputProps } from "#lib/components/flow/editor/data-types/inputs/dataTypeInput.js";
	import Button from "#lib/ui/Button/index.js";

	let { value = $bindable(), defaultValue, onchange }: DataTypeInputProps = $props();

	let showDefaults = $derived(arrayFromArrayValue(Array.isArray(value) ? value : undefined).length === 0);
	const defaultArray = arrayFromArrayValue(defaultValue);
	const defaultRows = defaultArray.length === 0 ? [""] : defaultArray;

	const array = arrayFromArrayValue(Array.isArray(value) ? value : undefined);
	let rows = $state(array.length === 0 ? defaultRows : array);

	function handleInput(index: number, event: Event) {
		const newValue = (event.target as HTMLInputElement).value;
		if (newValue === rows[index]) {
			return;
		}
		const next = [...rows];
		next[index] = newValue;
		rows = next;
		value = arrayToArrayValue(next);
	}

	function addRow() {
		const array = arrayFromArrayValue(Array.isArray(value) ? value : undefined);
		rows = array.length === 0 ? [""] : [...array, ""];
	}

	function removeRow(index: number, event: Event) {
		const next = rows.toSpliced(index, 1);
		rows = next.length === 0 ? [""] : next;
		value = arrayToArrayValue(rows);
		onchange?.(event);
	}
</script>

<div class="flex flex-col gap-2">
	{#each rows as row, index (index)}
		<div class="flex items-center gap-2">
			<Input type="text" class="min-w-0 flex-1" value={showDefaults ? "" : row} placeholder={showDefaults ? (defaultRows[index] as string) : undefined} on:focus={() => (showDefaults = false)} on:input={e => handleInput(index, e)} on:change={e => onchange?.(e)} />
			{#if rows.length > 1}
				<Button type="button" color="none" class="shrink-0 p-0" data-action-name="data-property-array-remove" on:click={e => removeRow(index, e)}>
					<Icon iconSet="heroicons" name="trash" class="h-5 w-5" />
					<span class="sr-only">Remove string {index + 1}</span>
				</Button>
			{/if}
		</div>
	{/each}
	<button type="button" class="text-primary-600 self-start text-sm hover:underline" data-action-name="data-property-array-add" onclick={addRow}>Add an additional string</button>
</div>
